
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { store } from '../redux/store';
import { refreshTokenThunk } from '../redux/auth/operations';
import { url as baseUrl } from 'components/other/terms';
import { jwtDecode } from 'jwt-decode';
import dayjs from 'dayjs';

let refreshingPromise = null;

export const createBaseQueryWithReauth = (subPath = '') => {
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: baseUrl + subPath,
        prepareHeaders: (headers) => headers, // ⛔️ Не ставимо токен тут!
    });

    return async (args, api, extraOptions) => {
        let token = store.getState().auth.access?.token;

        const decoded = token ? jwtDecode(token) : null;
        const isExpiredSoon =
            decoded && dayjs.unix(decoded.exp).diff(dayjs(), 'milliseconds') < 1000;

        if (isExpiredSoon || !token) {
            if (!refreshingPromise) {
                refreshingPromise = store
                    .dispatch(refreshTokenThunk())
                    .then(action => {
                        if (refreshTokenThunk.fulfilled.match(action)) {
                            return action.payload.access.token;
                        }
                        throw new Error('Refresh failed');
                    })
                    .finally(() => {
                        refreshingPromise = null;
                    });
            }

            try {
                token = await refreshingPromise;
            } catch {
                console.warn('Token refresh failed');
                // тут можна зробити logout або інші дії
            }
        }

        // ✅ Додаємо токен в ручну
        if (typeof args === 'string') {
            args = { url: args };
        }

        args.headers = {
            ...(args.headers || {}),
            authorization: token ? `Bearer ${token}` : '',
        };

        return rawBaseQuery(args, api, extraOptions);
    };
  };